import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { AppBar, Box, Button, Toolbar } from '@mui/material';
import ReceiveMethodEnum from '../../enums/ReceiveMethodEnum';
import api from '../../api';

@inject('commonStore', 'menuStore', 'cartStore', 'userStore', 'orderStore')
@observer
class Bottom extends Component {
  // 버튼 클릭
  confirm = async () => {
    const { t, history, location, match, commonStore, menuStore, cartStore, userStore, orderStore } = this.props;

    // 핸드폰 번호 검사
    var regExp = /^\d{11}$/g;
    if (userStore.userData.phoneNumber === '') {
      commonStore.setSnackbar(true, t('order.error.phoneRequired'));
      return;
    } else if (!regExp.test(userStore.userData.phoneNumber)) {
      commonStore.setSnackbar(true, t('order.error.phoneInvalid'));
      return;
    }

    // 배달인 경우 주소 검사
    if (cartStore.cartData.receiveMethodCode === ReceiveMethodEnum.DELIVERY) {
      if (menuStore.storeData.addressInputMethod !== '1' && (!userStore.userData.zipCode || !userStore.userData.sido)) {
        commonStore.setSnackbar(true, t('order.error.addressRequired'));
        return;
      } else if (menuStore.storeData.addressInputMethod === '1' && !userStore.userData.addressDetail) {
        commonStore.setSnackbar(true, t('order.error.addressRequired'));
        return;
      }
    }

    // 약관동의 체크
    if (!orderStore.agree) {
      commonStore.setSnackbar(true, t('order.error.privacyRequired'));
      return;
    }

    // 회원 포인트 조회
    if (menuStore.storeData.isPointUseable) {
      const response = await api.getUserPointByPhoneNumber(
        match.params.companyId.toLowerCase(),
        match.params.storeCode,
        userStore.userData.phoneNumber,
      );

      if (response.data.message === 'NOT_FOUND') {
        userStore.userData.isMember = false;
        userStore.saveUserData();

        history.push(`/${commonStore.companyId}/${commonStore.storeCode}/join${location.search}`);
        return;
      } else if (response.data.message === 'DUPLICATE') {
        userStore.userData.isMember = false;
        userStore.saveUserData();

        commonStore.setSnackbar(true, t('order.error.multipleMembersFound'));
        return;
      } else if (response.data.message === 'SUCCESS') {
        userStore.userData.isMember = true;
        userStore.userData.isPointAdded = true;
        userStore.saveUserData();

        userStore.setUserPoint(response.data.user.Point);
        history.push({
          pathname: `/${commonStore.companyId}/${commonStore.storeCode}/payment`,
          search: location.search,
          state: { isLiteOrder: orderStore.liteOrder ? true : false },
        });
        return;
      }
    }

    // 고객 입력 정보 브라우저에 저장
    userStore.saveUserData();

    // 결제 페이지로 이동
    history.push({
      pathname: `/${commonStore.companyId}/${commonStore.storeCode}/payment`,
      search: location.search,
      state: { isLiteOrder: orderStore.liteOrder ? true : false },
    });
  };

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <AppBar position="fixed" color="primary" className="bottom">
          <Toolbar variant="dense" style={{ padding: '0' }}>
            <Button fullWidth onClick={this.confirm} className="bottom-button">
              <Box className="bottom-button-title">{t('payment.button.pay')}</Box>
            </Button>
          </Toolbar>
        </AppBar>
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(Bottom));
